/*******************************************************************************
Insert Freestar Sticky Ads
Add sticky ads to the page on mobile and on some desktop pages
*******************************************************************************/

function configureFreestarStickyAds(){
    if (!window.freestar?.queue) { return; }

    // Add sticky ad to the bottom of the page on mobile
    window.freestar.queue.push(function(){
        window.freestar.newStickyFooter("rotowire_adhesion");
    });

    const isLoggedInUser = $('.rwnav-top-account').length > 0;

    // Add sticky ad to the bottom of the page on desktop (if the user is not logged in)
    if (!isLoggedInUser) {
        const desktopPages = [
            '/basketball/nba-lineups.php',
            '/baseball/daily-lineups.php',
            '/soccer/lineups.php',
            '/football/lineups.php',
            '/wnba/lineups.php',
            '/euro/daily-lineups.php',
        ];
        const currentPage = window.location.pathname;
        const desktopStickyShouldAppear = desktopPages.some(page => currentPage.includes(page));

        if (desktopStickyShouldAppear) {
            window.freestar.queue.push(function(){
                window.freestar.newStickyFooter("rotowire_adhesion_desktop");
            });
        }
    }
}

export default function insertFreestarStickyAds(){
    if (window.freestar?.queue) { return configureFreestarStickyAds(); }
    $(window).on("load", configureFreestarStickyAds);
}
